import { render, staticRenderFns } from "./rankingChart.vue?vue&type=template&id=2b9dcba8&scoped=true"
import script from "./rankingChart.vue?vue&type=script&lang=js"
export * from "./rankingChart.vue?vue&type=script&lang=js"
import style0 from "./rankingChart.vue?vue&type=style&index=0&id=2b9dcba8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9dcba8",
  null
  
)

export default component.exports